import React, { useState, useEffect } from 'react';

const CommentForm = ({
  onSubmit,
  onCancel,
  initialValue = '',
  placeholder = 'Drop your take...',
  submitButtonText = 'Post',
  isReply = false
}) => {
  const [content, setContent] = useState(initialValue);
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    setContent(initialValue);
  }, [initialValue]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!content.trim() || isSubmitting) return;

    setIsSubmitting(true);
    try {
      await onSubmit(content);
      setContent('');
    } catch (error) {
      console.error('Error submitting comment:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleCancel = () => {
    setContent(initialValue);
    onCancel?.();
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-3">
      <textarea
        value={content}
        onChange={(e) => setContent(e.target.value)}
        placeholder={placeholder}
        rows={isReply ? 2 : 3}
        maxLength={2000}
        autoFocus={isReply}
        className="input-field resize-none"
      />

      <div className="flex items-center justify-between">
        <span className="text-xs text-gray-500">
          {content.length}/2000
        </span>

        <div className="flex space-x-2">
          {onCancel && (
            <button
              type="button"
              onClick={handleCancel}
              disabled={isSubmitting}
              className="btn-secondary text-sm !py-2 !px-4"
            >
              Cancel
            </button>
          )}

          <button
            type="submit"
            disabled={!content.trim() || isSubmitting}
            className="btn-primary text-sm !py-2 !px-5 disabled:opacity-40 disabled:cursor-not-allowed disabled:hover:scale-100 disabled:hover:shadow-none"
          >
            {isSubmitting ? 'Posting...' : submitButtonText}
          </button>
        </div>
      </div>
    </form>
  );
};

export default CommentForm;
